import { Box, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useTranslation } from "react-i18next";
import { DIALOG_COLORS, DIALOG_FONT_FAMILY } from "./styles";

const AudienceNote = () => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				backgroundColor: DIALOG_COLORS.noteBackground,
				borderRadius: "6px",
				px: 2,
				py: 1.25,
				mt: 2,
			}}
		>
			<Typography sx={{ fontFamily: DIALOG_FONT_FAMILY, fontSize: 14, color: DIALOG_COLORS.noteText }}>
				<VisibilityOutlinedIcon sx={{ fontSize: 18, verticalAlign: "text-bottom", mr: 0.75 }} />
				<Box component="span" sx={{ fontWeight: 700 }}>
					{t("site_visit_comment.dialog.audience_note_bold")}
				</Box>
				{t("site_visit_comment.dialog.audience_note")}
			</Typography>
		</Box>
	);
};

export default AudienceNote;
